<script setup lang="ts">
  import {
    computed,
    markRaw,
    onMounted,
    onUnmounted,
    ref,
    type Component,
  } from 'vue';

  import ConfigProvider from '@core/services/ConfigProvider';

  defineOptions({
    inheritAttrs: false,
  });

  const props = defineProps<{
    size?: string | number;
  }>();

  const clientLoadingIcon = ref<Component | null>(null);

  let loadCancelled = false;
  onUnmounted(() => {
    loadCancelled = true;
  });

  const spinnerStyle = computed(() => {
    let sizeValue = '50px';
    if (typeof props.size === 'number') {
      sizeValue = `${props.size}px`;
    } else if (props.size !== undefined && props.size !== '') {
      sizeValue = props.size;
    }
    return {
      width: sizeValue,
      height: sizeValue,
    };
  });

  onMounted(async () => {
    const client = ConfigProvider.value('client');

    if (client && client !== 'default') {
      try {
        const loadingIconModule = await import(
          `../../externalDevportal/clients/${client}/components/LoadingIcon.vue`
        );
        if (!loadCancelled) {
          clientLoadingIcon.value = markRaw(loadingIconModule.default);
        }
      } catch (error) {
        console.warn(
          `Failed to load client loading icon for ${client}:`,
          error,
        );
      }
    }
  });
</script>

<template>
  <div
    class="flex items-center justify-center"
    v-bind="$attrs">
    <component
      :is="clientLoadingIcon"
      v-if="clientLoadingIcon"
      :size="size" />
    <div
      v-else
      class="relative flex items-center justify-center"
      :style="spinnerStyle">
      <!-- Outer Ring -->
      <div
        class="absolute inset-0 rounded-full border-4 border-gray-200
          dark:border-gray-700"></div>
      <!-- Spinning Ring -->
      <div
        class="absolute inset-0 rounded-full border-4 border-brand-primary
          border-t-transparent animate-spin"></div>
    </div>
  </div>
</template>
